module.exports = __webpack_public_path__ + "static/laure-bf86e8394f8f9f2576b02dd8de481739.png";